export interface Recipient {
  id: string
  name: string
  email: string
  phone?: string
  createdAt: string
  attended?: boolean
  answers?: Record<string, any>
}

export interface RecipientFilters {
  allAttendees: boolean
  fieldSelections: Record<string, string[]>
  sessionSelections: Record<string, string[]>
  attendanceSelections: string[]
}

export interface RecipientSelectionResult {
  recipientIds: string[]
  recipients: Recipient[]
  filters: RecipientFilters
}

export const defaultRecipientFilters: RecipientFilters = {
  allAttendees: false,
  fieldSelections: {},
  sessionSelections: {},
  attendanceSelections: [],
}

export interface FilterFieldOption {
  id: number
  label: string
  value: string
}

export interface FilterSessionOption {
  id: number
  label: string
  agendaSessionId: number
}

export interface FilterFieldGroup {
  fieldId: number
  label: string
  identifier: string
  options: FilterFieldOption[]
}

export interface FilterSessionGroup {
  fieldId: number
  label: string
  identifier: string
  options: FilterSessionOption[]
}

export type RecipientFilterOptions = {
  fields: FilterFieldGroup[]
  sessionChoices: FilterSessionGroup[]
}
